module.exports = __webpack_public_path__ + "static/media/MacOS_wordmark_white.20c2e1fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MacOS_wordmark_white.svg
// module id = 471
// module chunks = 21